import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../components/ui/Button';

const CompanyMenuPage: React.FC = () => {
    const navigate = useNavigate();

    const handleCompanyProfile = () => {
        navigate('/company', { state: { from: 'companyMenu' } });
    };

    const handleCompanyRequirements = () => {
        navigate('/company-requirements');
    };

    const handleGoBack = () => {
        navigate('/dashboard');
    };

    return (
        <div className="container">
            <div className="header">
                <h1>🏢 Company Menu</h1>
                <p>Manage your company information and requirements</p>
            </div>

            <div className="form-container">
                <div className="menu-buttons-container">
                    <button 
                        className="menu-button"
                        onClick={handleCompanyProfile}
                    >
                        <div className="menu-button-content">
                            <span className="menu-icon">👤</span>
                            <div className="menu-text">
                                <h3>Company Profile</h3>
                                <p>View and update company information</p>
                            </div>
                            <span className="menu-arrow">→</span>
                        </div>
                    </button>

                    <button 
                        className="menu-button"
                        onClick={handleCompanyRequirements}
                    >
                        <div className="menu-button-content">
                            <span className="menu-icon">📄</span>
                            <div className="menu-text">
                                <h3>Company Requirements</h3>
                                <p>View and manage company requirements</p>
                            </div>
                            <span className="menu-arrow">→</span>
                        </div>
                    </button>
                </div>

                <div className="action-buttons" style={{ marginTop: '30px' }}>
                    <Button variant="secondary" onClick={handleGoBack}>
                        ← Go Back
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default CompanyMenuPage;

